import tfyCard from '../images/tfy/tfy-card.png';
import tfyLayout from '../images/tfy/tfy-pages-laid-out.png';
import tfyMBPiPad from '../images/tfy/tfy-mackbook-ipad-website.png';
import tfyStickers from '../images/tfy/stickers.webp';
import wspCard from '../images/wsp/wsp-card.png';
import wspLayout from '../images/wsp/wsp-layout-pages.png';
import cp3Card from '../images/plaza3/cp3-card.png';
import claridgeMarket from '../images/plaza3/byward.jpg';
import plaza3Building from '../images/plaza3/242-rideau-building.jpg';
import plazaTowers from '../images/plaza3/plaza-towers.jpg';
import rideauSt from '../images/plaza3/rideau-st.jpg';
import plaza3LowerTerrace from '../images/plaza3/plaza3-lower-terrace.jpg';
import plaza3UpperTerrace from '../images/plaza3/plaza3-upper-terrace.jpg';
import plaza3Website from '../images/plaza3/plaza3-website.png';
import ceCard from '../images/cella-estates/cella-estates-card.webp';
import mapleSyrup1 from '../images/cella-estates/maple-syrup-1.webp';
import mapleSyrup2 from '../images/cella-estates/maple-syrup-2.webp';
import bottleRender from '../images/cella-estates/bottle-render.webp';

export const PROJECTS = [
  {
    id: 1,
    brand: 'Time For You',
    pageTitle: 'Helping People Feel Amazing in Their Skin',
    description: 'Time For You is Ottawa\'s leading electrolysis clinic and plays a vital role in enabling people to look how they feel. We built a brand to match.',
    // description: 'Creating equity by supporting local businesses that serve equity deserving groups.',
    image: tfyCard,
    link: '/project/time-for-you',
    className: 'card-dark',
    content: (
      <>
        {/* <div className='full-width-color mb-0'>
          Laptop image here.
        </div> */}
        <img src={tfyMBPiPad} alt="Time For You Website on Desktop and Tablet" className='full-width-image mb-0' />
        <div className='container my-5'>
          <div className="row">
            <div className="col">
              <p>We created a website that reflects Time For You's brand and values. The more professional and clinical aesthetic communicates how Time For You stands out from their competitors and creates a welcoming, trustworthy, and inclusive experience for their clients.</p>
              <p>Additionally, we optimized admin workflows to enhance security, improve ease of use, and ensure timely email management, reducing the risk of important messages slipping through the cracks.</p>
              <p>Photography was also a key component of the project, helping to showcase the clinic's professional environment, professional staff, and the positive experiences of their clients.
                Staff portraits were taken for the booking platform and website. Shots of the office were also taken for the website.</p>
            </div>
          </div>
        </div>
        <img src={tfyLayout} alt="Time For You Website pages" className='full-width-image my-0' />
        <div className='container my-5'>
          <div className="row">
            <div className="col">
              <p>For promotional material, we created custom stickers that help show the clinic and its commitment to inclusion.
                The designs include a pride flag and trans flag integrated into the company logo.</p>
              <img src={tfyStickers} alt="Time For You Pride Stickers" className='full-width-image my-0' />
            </div>
          </div>
        </div>
      </>
    ),
    testimonials: [
      {
        quote: 'Phoenix Unity Designs did an amazing job creating a new brand and website for our business. They took the time to understand our vision and values, and translated that into a beautiful and functional design. We have received so many compliments on our new look, and it has helped us attract new clients and grow our business. We highly recommend Phoenix Unity Designs to anyone looking for high-quality design work.',
        author: 'Veronica Allenger, Owner of Time For You',
      }
    ]
  },
  {
    id: 2,
    brand: 'West Side Pride',
    pageTitle: 'Addressing 2SLGBTQIA+ Issues Through Celebration',
    // pageTitle: 'Celebrating Diversity and Inclusion in Ottawa\'s West End',
    description: 'Ottawa\'s west end 2SLGBTQIA+ festival, was a scrappy underdog with big dreams of tackling systemic oppression through celebrating diversity and inclusion starting in the local community. Now, they are.',
    image: wspCard,
    link: '/project/west-side-pride',
    className: 'card-dark',
    content: (
      <>
        <img src={wspLayout} alt="West Side Pride Website pages" className='full-width-image mb-0' />
        <div style={{width: '100%', background: 'linear-gradient(43deg, rgba(244,153,166,1) 0%, rgba(238,54,54,1) 20%, rgba(252,181,25,1) 40%, rgba(139,208,205,1) 60%, rgba(8,102,131,1) 80%, rgba(97,53,98,1) 100%)', color: '#000'}} className='full-width-color my-0'>
          <div className='container mb-5'>
            <div className="row">
              <div className="col my-5">
                <p>Our team created the West Side Pride website and branding guide to ensure consistency across all digital and physical touchpoints.</p>
                <p>We also provided end-to-end stage and sound production to support their flagship event. This included setting up sound equipment, mixing board, scheduling, stage management, and managing all technical aspects of the event.</p>
              </div>
            </div>
          </div>
        </div>
        <div className='container mb-5'>
          <div className="row">
            <div className="col my-5">
              <p>Additionally, we created the West Side Pride 2026 Celebration Recap video.</p>
              <div class="ratio ratio-16x9 mb-4">
                <iframe src="https://www.youtube.com/embed/-RI5Ouf-59w" title="West Side Pride 2026 Celebration Recap" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  },
  {
    id: 3,
    brand: 'Claridge Plaza 3',
    pageTitle: 'Revealing Opportunity in Ottawa\'s Urban Core',
    description: 'Residents without updates and left with questions. Untimely notices that never made it to owners that lived outside the building. Growing tension and anxiety from owners over condo board cohesion that could depress property value. We listened, and we turned that around.',
    image: cp3Card,
    link: '/project/clairidge-plaza-3',
    className: 'card-dark',
    content: (
      <>
        <img src={plaza3Website} alt="Claridge Plaza 3 Website" className='full-width-image my-0' />
        <div className='container'>
          <div className="row">
            <div className="col">
              <p>Our team designed and developed a clean, user-friendly website that works well on all devices. We organized the content so residents can quickly access forms, updates, and contact details.</p>
            </div>
          </div>
        </div>
        <div className='full-width-color my-0 d-flex'>
          <div className='half-width-image'>
            <img src={plaza3Building} alt="Claridge Plaza 3 Building" className='portrait' />
          </div>
          <div className='half-width-image'>
            <img src={rideauSt} alt="Rideau Street" className='portrait' />
          </div>
        </div>
        <img src={plaza3LowerTerrace} alt="Claridge Plaza 3 Lower Terrace" className='full-width-image my-0' />
        <div className='container'>
          <div className="row">
            <div className="col">
              <p>We also handled original photography, capturing both the building’s character and the surrounding neighbourhood to show what makes Claridge Plaza 3 special. The design and images work together to reflect the condo’s modern, stylish atmosphere.</p>
            </div>
          </div>
        </div>
        <div className='full-width-color my-0 d-flex'>
          <div className='half-width-image'>
            <img src={claridgeMarket} alt="ByWard Market" className='landscape' />
          </div>
          <div className='half-width-image'>
            <img src={plazaTowers} alt="Claridge Plaza Towers" className='portrait' style={{marginTop: '-20%'}} />
          </div>
        </div>
        <img src={plaza3UpperTerrace} alt="Claridge Plaza 3 Upper Terrace" className='full-width-image my-0' />
      </>
    )
  },
  {
    id: 4,
    brand: 'Cella Estates',
    pageTitle: 'Giving a Sweet Look to Maple Syrup',
    description: 'Cella Estates produces artisanal maple syrup of the highest quality. We built their custom bottle labels to match the premium nature of their product and help them stand out in a competitive market.',
    image: ceCard,
    link: '/project/cella-estates',
    className: 'card-dark',
    content: (
      <>
        <img src={mapleSyrup2} alt="Maple Syrup Bottles" className='full-width-image my-0' />
        <div className='container'>
          <div className="row">
            <div className="col">
              <p>We built custom bottle labels that match the premium nature of their product and help them make a bigger impression with customers. This professional label elevates their brand.</p>
            </div>
          </div>
        </div>
        <div className='full-width-color my-0 d-flex'>
          <div className='half-width-image'>
            <img src={mapleSyrup1} alt="Maple Syrup Bottles" className='portrait' />
          </div>
          <div className='half-width-image'>
            <img src={bottleRender} alt="Bottle Render" className='portrait' />
          </div>
        </div>
      </>
    )
  },
  // {
  //   id: 4,
  //   brand: 'Project 4',
  //   description: 'Short description of Project 4.',
  //   image: card,
  //   link: '/project/project4',
  //   content: (
  //     <>
  //       <h1>Project 4</h1>
  //       <p>Short description of Project 4.</p>
  //       <p>Full project details and content go here.</p>
  //     </>
  //   )
  // },
  // {
  //   id: 5,
  //   brand: 'Project 5',
  //   description: 'Short description of Project 5.',
  //   image: card,
  //   link: '/project/project5',
  //   content: (
  //     <>
  //       <h1>Project 5</h1>
  //       <p>Short description of Project 5.</p>
  //       <p>Full project details and content go here.</p>
  //     </>
  //   )
  // },
  // {
  //   id: 6,
  //   brand: 'Project 6',
  //   description: 'Short description of Project 6.',
  //   image: card,
  //   link: '/project/project6',
  //   content: (
  //     <>
  //       <h1>Project 6</h1>
  //       <p>Short description of Project 6.</p>
  //       <p>Full project details and content go here.</p>
  //     </>
  //   )
  // }
];
